import { render, staticRenderFns } from "./FixedBottomList.vue?vue&type=template&id=61969300&scoped=true&"
import script from "./FixedBottomList.vue?vue&type=script&lang=js&"
export * from "./FixedBottomList.vue?vue&type=script&lang=js&"
import style0 from "./FixedBottomList.vue?vue&type=style&index=0&id=61969300&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61969300",
  null
  
)

export default component.exports